import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'lane', 'Lane', [["path",{"d":"M4 6v13"}],["path",{"d":"M20 6v13"}]]);